import { useTranslations } from 'next-intl';

import { UiKitRatingBlock } from '@/fo/ui/kit/rating/block';
import { ReviewsData } from '@/fo/ui/review/catalog/base';

import { styles } from './ReviewsHeader.styles';

export interface ReviewsHeaderProps {
  reviewsData: ReviewsData;
  className?: string;
}

export function ReviewsHeader({ reviewsData, className }: ReviewsHeaderProps) {
  const t = useTranslations();
  const slots = styles();

  return (
    <div className={slots.container({ className })}>
      <div className={slots.ratingBlock()}>
        <UiKitRatingBlock value={reviewsData.rating} />
        {reviewsData?.totalCount > 0 && (
          <span>
            {reviewsData?.totalCount}&nbsp;
            {t.rich('review.pluralizeItems', {
              count: reviewsData?.totalCount
            })}
          </span>
        )}
      </div>
    </div>
  );
}
